module.exports = __webpack_public_path__ + "img/97de6cc.png";